import * as navigation from 'Navigation';

export default class PlateTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Plate',
      closeable: false,
      preferenceKey: 'plate',
    };
  }
}
